import script from "./Child.vue?vue&type=script&setup=true&lang=ts"
export * from "./Child.vue?vue&type=script&setup=true&lang=ts"

import "./Child.vue?vue&type=style&index=0&id=5f169dc4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f169dc4"]])

export default __exports__